import { buildProps } from '@vuesax-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type CheckboxGroup from './checkbox-group.vue'

export const checkboxGroupProps = buildProps({})

export type CheckboxGroupProps = ExtractPropTypes<typeof checkboxGroupProps>
export type CheckboxGroupInstance = InstanceType<typeof CheckboxGroup>
